import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid, PieChart, Pie, Cell, LineChart, Line, Legend } from 'recharts';
// VELİ PANELİ İÇİN RENK PALETİ
const VELI_DERS_RENKLERI = {
  MATEMATİK: 'from-blue-600 to-blue-800',
  TÜRKÇE: 'from-red-600 to-red-800',
  'FEN BİLİMLERİ': 'from-green-600 to-green-800',
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': 'from-yellow-600 to-yellow-800',
  İNGİLİZCE: 'from-purple-600 to-purple-800',
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': 'from-indigo-600 to-indigo-800'
};
// TÜM DENEMELERE AİT KONU VERİLERİNİ TANIMLA
const allExamsData = [{
  id: 'lgs8',
  name: 'LGS 8',
  date: '2024-01-30',
  net: 84,
  totalCorrect: 85,
  totalWrong: 3,
  totalEmpty: 2,
  totalNet: 84,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 19,
    wrong: 0,
    empty: 1,
    net: 19,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 4,
      wrong: 0,
      empty: 1,
      net: 4,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 20,
    wrong: 0,
    empty: 0,
    net: 20,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs7',
  name: 'LGS 7',
  date: '2023-12-15',
  net: 76,
  totalCorrect: 80,
  totalWrong: 5,
  totalEmpty: 5,
  totalNet: 78.33,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 1,
      empty: 1,
      net: 2.67,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 9,
    wrong: 0,
    empty: 1,
    net: 9,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 9,
    wrong: 0,
    empty: 1,
    net: 9,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs6',
  name: 'LGS 6',
  date: '2023-12-01',
  net: 72,
  totalCorrect: 75,
  totalWrong: 7,
  totalEmpty: 8,
  totalNet: 72,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 15,
    wrong: 3,
    empty: 2,
    net: 14,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 17,
    wrong: 2,
    empty: 1,
    net: 16.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 4,
      wrong: 0,
      empty: 1,
      net: 4,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 17,
    wrong: 1,
    empty: 2,
    net: 16.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 9,
    wrong: 0,
    empty: 1,
    net: 9,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 9,
    wrong: 0,
    empty: 1,
    net: 9,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs5',
  name: 'LGS 5',
  date: '2023-11-15',
  net: 68,
  totalCorrect: 70,
  totalWrong: 5,
  totalEmpty: 15,
  totalNet: 68,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 14,
    wrong: 1,
    empty: 5,
    net: 13.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 16,
    wrong: 1,
    empty: 3,
    net: 15.67,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 0,
    empty: 2,
    net: 8,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 8,
    wrong: 0,
    empty: 2,
    net: 8,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 0,
      wrong: 0,
      empty: 2,
      net: 0,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs4',
  name: 'LGS 4',
  date: '2023-11-01',
  net: 65,
  totalCorrect: 69,
  totalWrong: 10,
  totalEmpty: 11,
  totalNet: 65,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 13,
    wrong: 4,
    empty: 3,
    net: 11.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 0,
    empty: 2,
    net: 8,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs3',
  name: 'LGS 3',
  date: '2023-10-15',
  net: 59,
  totalCorrect: 62,
  totalWrong: 8,
  totalEmpty: 20,
  totalNet: 59,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 12,
    wrong: 3,
    empty: 5,
    net: 11,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 15,
    wrong: 1,
    empty: 4,
    net: 14.67,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 14,
    wrong: 2,
    empty: 4,
    net: 13.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 1,
      wrong: 1,
      empty: 1,
      net: 0.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 7,
    wrong: 0,
    empty: 3,
    net: 7,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs2',
  name: 'LGS 2',
  date: '2023-10-01',
  net: 61,
  totalCorrect: 65,
  totalWrong: 10,
  totalEmpty: 15,
  totalNet: 61,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 12,
    wrong: 4,
    empty: 4,
    net: 10.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 15,
    wrong: 2,
    empty: 3,
    net: 14.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 0,
    empty: 2,
    net: 8,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs1',
  name: 'LGS 1',
  date: '2023-09-15',
  net: 54,
  totalCorrect: 60,
  totalWrong: 18,
  totalEmpty: 12,
  totalNet: 54,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 8,
    wrong: 8,
    empty: 4,
    net: 5.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 0,
      wrong: 2,
      empty: 0,
      net: -0.67,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 0,
      wrong: 0,
      empty: 2,
      net: 0,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 14,
    wrong: 2,
    empty: 4,
    net: 13.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 13,
    wrong: 2,
    empty: 5,
    net: 12.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 1,
      wrong: 1,
      empty: 1,
      net: 0.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 7,
    wrong: 0,
    empty: 3,
    net: 7,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}];
// Konu listeleri
const konuListeleri = {
  MATEMATİK: ['Çarpanlar ve Katlar', 'Üslü Sayılar', 'Köklü Sayılar', 'Veri Analizi', 'Olasılık', 'Cebirsel İfadeler', 'Doğrusal Denklemler ve Eğim', 'Eşitsizlikler', 'Üçgenler', 'Eşlik ve Benzerlik', 'Dönüşüm Geometrisi', 'Geometrik Cisimler'],
  TÜRKÇE: ['Sözcükte Anlam', 'Deyimler ve Atasözleri', 'Cümlede Anlam', 'Sözel Mantık / Görsel Okuma', 'Parçada Anlam', 'Söz Sanatları', 'Metin Türleri', 'Noktalama İşaretleri', 'Yazım Kuralları', 'Fiilimsiler', 'Cümlenin Öğeleri', 'Cümle Türleri', 'Anlatım Bozukluğu'],
  'FEN BİLİMLERİ': ['Mevsimler ve İklim', 'DNA ve Genetik Kod', 'Basınç', 'Madde ve Endüstri', 'Basit Makineler', 'Enerji Dönüşümleri ve Çevre Bilimi', 'Elektrik Yükleri ve Elektrik Enerjisi'],
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': ['Bir Kahraman Doğuyor', 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar', 'Milli Bir Destan: Ya İstiklal, Ya Ölüm', 'Atatürkçülük ve Çağdaşlaşan Türkiye', 'Demokratikleşme Çabaları', 'Atatürk Dönemi Dış Politika', "Atatürk'ün Ölümü ve Sonrası"],
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': ['Kader İnancı', 'Bir Peygamber Tanıyorum: Hz. Musa', 'Zekat ve Sadaka', 'Din ve Hayat', "Hz. Muhammed'in Örnekliği", "Kur'an-ı Kerim ve Özellikleri", "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem", 'İslam Dinine Göre Kötü Davranışlar', 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)', 'Hac ibadeti'],
  İNGİLİZCE: ['Friendship', 'Teen Life', 'In The Kitchen', 'On The Phone', 'The Internet', 'Adventures', 'Tourism', 'Chores', 'Science', 'Natural Forces']
};
// En çok hata yapılan konular verisi
const mostMistakesData = {
  MATEMATİK: [{
    topic: 'Eşitsizlikler',
    mistakes: 6,
    success: 66.7
  }, {
    topic: 'Dönüşüm Geometrisi',
    mistakes: 5,
    success: 66.7
  }, {
    topic: 'Cebirsel İfadeler',
    mistakes: 9,
    success: 75.0
  }],
  TÜRKÇE: [{
    topic: 'Fiilimsiler',
    mistakes: 6,
    success: 62.5
  }, {
    topic: 'Anlatım Bozukluğu',
    mistakes: 9,
    success: 58.3
  }, {
    topic: 'Cümle Türleri',
    mistakes: 7,
    success: 68.8
  }],
  'FEN BİLİMLERİ': [{
    topic: 'Madde ve Endüstri',
    mistakes: 10,
    success: 72.7
  }, {
    topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
    mistakes: 7,
    success: 77.8
  }, {
    topic: 'Basınç',
    mistakes: 4,
    success: 75.0
  }],
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': [{
    topic: 'Atatürk Dönemi Dış Politika',
    mistakes: 6,
    success: 66.7
  }, {
    topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
    mistakes: 6,
    success: 83.3
  }, {
    topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    mistakes: 4,
    success: 85.0
  }],
  İNGİLİZCE: [{
    topic: 'Natural Forces',
    mistakes: 3,
    success: 75.0
  }, {
    topic: 'The Internet',
    mistakes: 4,
    success: 83.3
  }, {
    topic: 'Science',
    mistakes: 4,
    success: 81.5
  }],
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': [{
    topic: 'İslam Dinine Göre Kötü Davranışlar',
    mistakes: 5,
    success: 66.7
  }, {
    topic: 'Hac ibadeti',
    mistakes: 3,
    success: 66.7
  }, {
    topic: "Kur'an-ı Kerim ve Özellikleri",
    mistakes: 3,
    success: 83.3
  }]
};
// Grafik verisini doğru sırala - LGS 1'den LGS 8'e doğru sırala
const lgsExamData = [{
  name: 'LGS 1',
  date: '2023-09-15',
  net: 54,
  maxNet: 90
}, {
  name: 'LGS 2',
  date: '2023-10-01',
  net: 61,
  maxNet: 90
}, {
  name: 'LGS 3',
  date: '2023-10-15',
  net: 59,
  maxNet: 90
}, {
  name: 'LGS 4',
  date: '2023-11-01',
  net: 65,
  maxNet: 90
}, {
  name: 'LGS 5',
  date: '2023-11-15',
  net: 68,
  maxNet: 90
}, {
  name: 'LGS 6',
  date: '2023-12-01',
  net: 72,
  maxNet: 90
}, {
  name: 'LGS 7',
  date: '2023-12-15',
  net: 76,
  maxNet: 90
}, {
  name: 'LGS 8',
  date: '2024-01-30',
  net: 84,
  maxNet: 90
}];
// Tüm denemeler konu bazlı istatistik verisi
const tumDenemelerKonuAnalizi = {
  MATEMATİK: [{
    topic: 'Çarpanlar ve Katlar',
    correct: 45,
    wrong: 3,
    empty: 0,
    totalQuestions: 48,
    accuracy: 93.75
  }, {
    topic: 'Üslü Sayılar',
    correct: 42,
    wrong: 4,
    empty: 2,
    totalQuestions: 48,
    accuracy: 87.5
  }, {
    topic: 'Köklü Sayılar',
    correct: 40,
    wrong: 5,
    empty: 3,
    totalQuestions: 48,
    accuracy: 83.33
  }, {
    topic: 'Veri Analizi',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67
  }, {
    topic: 'Olasılık',
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33
  }, {
    topic: 'Cebirsel İfadeler',
    correct: 36,
    wrong: 9,
    empty: 3,
    totalQuestions: 48,
    accuracy: 75.0
  }, {
    topic: 'Doğrusal Denklemler ve Eğim',
    correct: 38,
    wrong: 7,
    empty: 3,
    totalQuestions: 48,
    accuracy: 79.17
  }, {
    topic: 'Eşitsizlikler',
    correct: 16,
    wrong: 6,
    empty: 2,
    totalQuestions: 24,
    accuracy: 66.67
  }, {
    topic: 'Üçgenler',
    correct: 32,
    wrong: 7,
    empty: 1,
    totalQuestions: 40,
    accuracy: 80.0
  }, {
    topic: 'Eşlik ve Benzerlik',
    correct: 18,
    wrong: 4,
    empty: 2,
    totalQuestions: 24,
    accuracy: 75.0
  }, {
    topic: 'Dönüşüm Geometrisi',
    correct: 16,
    wrong: 5,
    empty: 3,
    totalQuestions: 24,
    accuracy: 66.67
  }, {
    topic: 'Geometrik Cisimler',
    correct: 25,
    wrong: 6,
    empty: 1,
    totalQuestions: 32,
    accuracy: 78.13
  }],
  TÜRKÇE: [{
    topic: 'Sözcükte Anlam',
    correct: 38,
    wrong: 2,
    empty: 0,
    totalQuestions: 40,
    accuracy: 95.0
  }, {
    topic: 'Deyimler ve Atasözleri',
    correct: 35,
    wrong: 3,
    empty: 2,
    totalQuestions: 40,
    accuracy: 87.5
  }, {
    topic: 'Cümlede Anlam',
    correct: 37,
    wrong: 3,
    empty: 0,
    totalQuestions: 40,
    accuracy: 92.5
  }, {
    topic: 'Sözel Mantık / Görsel Okuma',
    correct: 28,
    wrong: 4,
    empty: 0,
    totalQuestions: 32,
    accuracy: 87.5
  }, {
    topic: 'Parçada Anlam',
    correct: 55,
    wrong: 7,
    empty: 2,
    totalQuestions: 64,
    accuracy: 85.94
  }, {
    topic: 'Söz Sanatları',
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33
  }, {
    topic: 'Metin Türleri',
    correct: 28,
    wrong: 3,
    empty: 1,
    totalQuestions: 32,
    accuracy: 87.5
  }, {
    topic: 'Noktalama İşaretleri',
    correct: 25,
    wrong: 2,
    empty: 1,
    totalQuestions: 28,
    accuracy: 89.29
  }, {
    topic: 'Yazım Kuralları',
    correct: 26,
    wrong: 4,
    empty: 2,
    totalQuestions: 32,
    accuracy: 81.25
  }, {
    topic: 'Fiilimsiler',
    correct: 15,
    wrong: 6,
    empty: 3,
    totalQuestions: 24,
    accuracy: 62.5
  }, {
    topic: 'Cümlenin Öğeleri',
    correct: 30,
    wrong: 5,
    empty: 1,
    totalQuestions: 36,
    accuracy: 83.33
  }, {
    topic: 'Cümle Türleri',
    correct: 22,
    wrong: 7,
    empty: 3,
    totalQuestions: 32,
    accuracy: 68.75
  }, {
    topic: 'Anlatım Bozukluğu',
    correct: 14,
    wrong: 9,
    empty: 1,
    totalQuestions: 24,
    accuracy: 58.33
  }],
  'FEN BİLİMLERİ': [{
    topic: 'Mevsimler ve İklim',
    correct: 25,
    wrong: 3,
    empty: 0,
    totalQuestions: 28,
    accuracy: 89.29
  }, {
    topic: 'DNA ve Genetik Kod',
    correct: 38,
    wrong: 4,
    empty: 2,
    totalQuestions: 44,
    accuracy: 86.36
  }, {
    topic: 'Basınç',
    correct: 18,
    wrong: 4,
    empty: 2,
    totalQuestions: 24,
    accuracy: 75.0
  }, {
    topic: 'Madde ve Endüstri',
    correct: 32,
    wrong: 10,
    empty: 2,
    totalQuestions: 44,
    accuracy: 72.73
  }, {
    topic: 'Basit Makineler',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67
  }, {
    topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
    correct: 28,
    wrong: 3,
    empty: 1,
    totalQuestions: 32,
    accuracy: 87.5
  }, {
    topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
    correct: 28,
    wrong: 7,
    empty: 1,
    totalQuestions: 36,
    accuracy: 77.78
  }],
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': [{
    topic: 'Bir Kahraman Doğuyor',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67
  }, {
    topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    correct: 34,
    wrong: 4,
    empty: 2,
    totalQuestions: 40,
    accuracy: 85.0
  }, {
    topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
    correct: 30,
    wrong: 6,
    empty: 0,
    totalQuestions: 36,
    accuracy: 83.33
  }, {
    topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
    correct: 25,
    wrong: 3,
    empty: 0,
    totalQuestions: 28,
    accuracy: 89.29
  }, {
    topic: 'Demokratikleşme Çabaları',
    correct: 15,
    wrong: 2,
    empty: 1,
    totalQuestions: 18,
    accuracy: 83.33
  }, {
    topic: 'Atatürk Dönemi Dış Politika',
    correct: 12,
    wrong: 6,
    empty: 0,
    totalQuestions: 18,
    accuracy: 66.67
  }, {
    topic: "Atatürk'ün Ölümü ve Sonrası",
    correct: 12,
    wrong: 2,
    empty: 1,
    totalQuestions: 15,
    accuracy: 80.0
  }],
  İNGİLİZCE: [{
    topic: 'Friendship',
    correct: 18,
    wrong: 2,
    empty: 0,
    totalQuestions: 20,
    accuracy: 90.0
  }, {
    topic: 'Teen Life',
    correct: 19,
    wrong: 2,
    empty: 1,
    totalQuestions: 22,
    accuracy: 86.36
  }, {
    topic: 'In The Kitchen',
    correct: 14,
    wrong: 1,
    empty: 0,
    totalQuestions: 15,
    accuracy: 93.33
  }, {
    topic: 'On The Phone',
    correct: 15,
    wrong: 3,
    empty: 0,
    totalQuestions: 18,
    accuracy: 83.33
  }, {
    topic: 'The Internet',
    correct: 20,
    wrong: 4,
    empty: 0,
    totalQuestions: 24,
    accuracy: 83.33
  }, {
    topic: 'Adventures',
    correct: 16,
    wrong: 3,
    empty: 1,
    totalQuestions: 20,
    accuracy: 80.0
  }, {
    topic: 'Tourism',
    correct: 14,
    wrong: 2,
    empty: 2,
    totalQuestions: 18,
    accuracy: 77.78
  }, {
    topic: 'Chores',
    correct: 12,
    wrong: 1,
    empty: 2,
    totalQuestions: 15,
    accuracy: 80.0
  }, {
    topic: 'Science',
    correct: 22,
    wrong: 4,
    empty: 1,
    totalQuestions: 27,
    accuracy: 81.48
  }, {
    topic: 'Natural Forces',
    correct: 18,
    wrong: 3,
    empty: 3,
    totalQuestions: 24,
    accuracy: 75.0
  }],
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': [{
    topic: 'Kader İnancı',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67
  }, {
    topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
    correct: 16,
    wrong: 2,
    empty: 0,
    totalQuestions: 18,
    accuracy: 88.89
  }, {
    topic: 'Zekat ve Sadaka',
    correct: 14,
    wrong: 1,
    empty: 0,
    totalQuestions: 15,
    accuracy: 93.33
  }, {
    topic: 'Din ve Hayat',
    correct: 18,
    wrong: 2,
    empty: 1,
    totalQuestions: 21,
    accuracy: 85.71
  }, {
    topic: "Hz. Muhammed'in Örnekliği",
    correct: 25,
    wrong: 2,
    empty: 0,
    totalQuestions: 27,
    accuracy: 92.59
  }, {
    topic: "Kur'an-ı Kerim ve Özellikleri",
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33
  }, {
    topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
    correct: 16,
    wrong: 1,
    empty: 1,
    totalQuestions: 18,
    accuracy: 88.89
  }, {
    topic: 'İslam Dinine Göre Kötü Davranışlar',
    correct: 12,
    wrong: 5,
    empty: 1,
    totalQuestions: 18,
    accuracy: 66.67
  }, {
    topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
    correct: 13,
    wrong: 2,
    empty: 0,
    totalQuestions: 15,
    accuracy: 86.67
  }, {
    topic: 'Hac ibadeti',
    correct: 12,
    wrong: 3,
    empty: 3,
    totalQuestions: 18,
    accuracy: 66.67
  }]
};
export function VeliDenemeAnalizleri() {
  const [activeTab, setActiveTab] = useState('all');
  const [currentExam, setCurrentExam] = useState(allExamsData[0]);
  const [showExamDropdown, setShowExamDropdown] = useState(false);
  const [activeSubjectTab, setActiveSubjectTab] = useState('MATEMATİK');
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  // Exam selection handler - UPDATED for data consistency
  const handleExamClick = exam => {
    console.log('Changing exam to:', exam.name); // Debug için
    setCurrentExam(exam);
    setShowExamDropdown(false);
    // Eğer seçilen denemede mevcut ders yoksa ilk dersi seç
    if (exam.subjects && exam.subjects.length > 0) {
      const firstSubject = exam.subjects[0].subject;
      setActiveSubjectTab(firstSubject);
      console.log('Setting active subject to first subject:', firstSubject); // Debug için
    }
  };
  // Get topic data for current exam and active subject - UPDATED with debug logs
  const getCurrentExamTopicData = () => {
    if (!currentExam || !currentExam.subjects) {
      console.log('No currentExam or subjects'); // Debug için
      return [];
    }
    const activeSubject = currentExam.subjects.find(s => s.subject === activeSubjectTab);
    if (!activeSubject) {
      console.log('No activeSubject found for:', activeSubjectTab); // Debug için
      return [];
    }
    if (!activeSubject.topics || activeSubject.topics.length === 0) {
      console.log('No topics for subject:', activeSubjectTab); // Debug için
      return [];
    }
    console.log('Found topics for', activeSubjectTab, ':', activeSubject.topics.length); // Debug için
    return activeSubject.topics;
  };
  return <div className="space-y-6" data-id="element-400">
      <h1 className="text-2xl font-bold" data-id="element-401">Deneme Analizleri</h1>
      {/* TAB MENU - LACİVERT TEMA */}
      <div className="p-[1px] rounded-lg bg-gradient-to-r from-blue-800 to-blue-600" data-id="element-402">
        <div className="p-1 bg-black/90 rounded-lg" data-id="element-403">
          <div className="grid grid-cols-3 gap-1" data-id="element-404">
            <button onClick={() => setActiveTab('all')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'all' ? 'bg-gradient-to-r from-blue-600 to-blue-800 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-405">
              Tüm Denemeler
            </button>
            <button onClick={() => setActiveTab('last')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'last' ? 'bg-gradient-to-r from-blue-600 to-blue-800 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-406">
              Son Deneme
            </button>
            <button onClick={() => setActiveTab('topic')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'topic' ? 'bg-gradient-to-r from-blue-600 to-blue-800 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-407">
              Konu Bazlı Genel Analiz
            </button>
          </div>
        </div>
      </div>
      {/* TÜM DENEMELER TAB */}
      {activeTab === 'all' && <div className="space-y-6" data-id="element-408">
          {/* Genel İstatistikler - LACİVERT TEMA */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-409">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-410">
              <h2 className="text-xl font-bold mb-4" data-id="element-411">Genel İstatistikler</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-412">
                {/* İstatistik Kartları */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-413">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-414">
                    <div className="text-sm text-gray-400" data-id="element-415">Toplam Deneme</div>
                    <div className="text-2xl font-bold text-white" data-id="element-416">8</div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-417">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-418">
                    <div className="text-sm text-gray-400" data-id="element-419">Ortalama Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-420">68.50</div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-421">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-422">
                    <div className="text-sm text-gray-400" data-id="element-423">En Yüksek Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-424">84</div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-425">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-426">
                    <div className="text-sm text-gray-400" data-id="element-427">En Düşük Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-428">54</div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-429">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-430">
                    <div className="text-sm text-gray-400" data-id="element-431">
                      En Başarılı Ders
                    </div>
                    <div className="text-2xl font-bold text-white" data-id="element-432">
                      Fen Bilimleri
                    </div>
                  </div>
                </div>
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-433">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-434">
                    <div className="text-sm text-gray-400" data-id="element-435">En Zayıf Ders</div>
                    <div className="text-2xl font-bold text-white" data-id="element-436">
                      Matematik
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* SORUN 1 ÇÖZÜMÜ: İlerleme Grafiği - LACİVERT TEMA - ARTAN SIRAYLA */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-437">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-438">
              <h2 className="text-xl font-bold mb-4" data-id="element-439">
                Deneme Sınavı Sonuçları
              </h2>
              <div className="h-80" data-id="element-440">
                <ResponsiveContainer width="100%" height="100%" data-id="element-441">
                  <LineChart data={lgsExamData} margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5
              }} data-id="element-442">
                    <CartesianGrid strokeDasharray="3 3" stroke="#333" data-id="element-443" />
                    <XAxis dataKey="name" stroke="#999" data-id="element-444" />
                    <YAxis stroke="#999" domain={[0, 90]} data-id="element-445" />
                    <Tooltip data-id="element-446" />
                    <Legend data-id="element-447" />
                    <Line type="monotone" dataKey="net" name="Net" stroke="#3b82f6" strokeWidth={2} dot={{
                  r: 6
                }} activeDot={{
                  r: 8
                }} data-id="element-448" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          {/* SORUN 2 ÇÖZÜMÜ: En Çok Hata Yapılan Konular - 6 DERS KARTI */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-449">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-450">
              <h2 className="text-xl font-bold mb-6" data-id="element-451">
                En Çok Hata Yapılan Konular
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-452">
                {/* MATEMATİK KARTI */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-453">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-454">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-455">
                      MATEMATİK
                    </h3>
                    <div className="space-y-4" data-id="element-456">
                      {mostMistakesData.MATEMATİK.map((item, index) => <div key={index} className="space-y-2" data-id="element-457">
                          <div className="flex justify-between items-center" data-id="element-458">
                            <span className="text-gray-300 font-medium" data-id="element-459">
                              {item.topic}
                            </span>
                          </div>
                          <div className="flex justify-between items-center text-sm" data-id="element-460">
                            <span className="text-red-400" data-id="element-461">
                              {item.mistakes} Yanlış
                            </span>
                            <span className="text-gray-400" data-id="element-462">
                              Başarı: {item.success.toFixed(1)}%
                            </span>
                          </div>
                          <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-463">
                            <div className="h-full bg-gradient-to-r from-blue-600 to-blue-800" style={{
                        width: `${item.success}%`
                      }} data-id="element-464" />
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
                {/* TÜRKÇE KARTI */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-red-600 to-red-800" data-id="element-465">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-466">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-467">
                      TÜRKÇE
                    </h3>
                    <div className="space-y-4" data-id="element-468">
                      {mostMistakesData.TÜRKÇE.map((item, index) => <div key={index} className="space-y-2" data-id="element-469">
                          <div className="flex justify-between items-center" data-id="element-470">
                            <span className="text-gray-300 font-medium" data-id="element-471">
                              {item.topic}
                            </span>
                          </div>
                          <div className="flex justify-between items-center text-sm" data-id="element-472">
                            <span className="text-red-400" data-id="element-473">
                              {item.mistakes} Yanlış
                            </span>
                            <span className="text-gray-400" data-id="element-474">
                              Başarı: {item.success.toFixed(1)}%
                            </span>
                          </div>
                          <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-475">
                            <div className="h-full bg-gradient-to-r from-red-600 to-red-800" style={{
                        width: `${item.success}%`
                      }} data-id="element-476" />
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
                {/* FEN BİLİMLERİ KARTI */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-green-600 to-green-800" data-id="element-477">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-478">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-479">
                      FEN BİLİMLERİ
                    </h3>
                    <div className="space-y-4" data-id="element-480">
                      {mostMistakesData['FEN BİLİMLERİ'].map((item, index) => <div key={index} className="space-y-2" data-id="element-481">
                          <div className="flex justify-between items-center" data-id="element-482">
                            <span className="text-gray-300 font-medium" data-id="element-483">
                              {item.topic}
                            </span>
                          </div>
                          <div className="flex justify-between items-center text-sm" data-id="element-484">
                            <span className="text-red-400" data-id="element-485">
                              {item.mistakes} Yanlış
                            </span>
                            <span className="text-gray-400" data-id="element-486">
                              Başarı: {item.success.toFixed(1)}%
                            </span>
                          </div>
                          <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-487">
                            <div className="h-full bg-gradient-to-r from-green-600 to-green-800" style={{
                        width: `${item.success}%`
                      }} data-id="element-488" />
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
                {/* T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK KARTI */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-yellow-600 to-yellow-800" data-id="element-489">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-490">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-491">
                      T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK
                    </h3>
                    <div className="space-y-4" data-id="element-492">
                      {mostMistakesData['T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK'].map((item, index) => <div key={index} className="space-y-2" data-id="element-493">
                          <div className="flex justify-between items-center" data-id="element-494">
                            <span className="text-gray-300 font-medium" data-id="element-495">
                              {item.topic}
                            </span>
                          </div>
                          <div className="flex justify-between items-center text-sm" data-id="element-496">
                            <span className="text-red-400" data-id="element-497">
                              {item.mistakes} Yanlış
                            </span>
                            <span className="text-gray-400" data-id="element-498">
                              Başarı: {item.success.toFixed(1)}%
                            </span>
                          </div>
                          <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-499">
                            <div className="h-full bg-gradient-to-r from-yellow-600 to-yellow-800" style={{
                        width: `${item.success}%`
                      }} data-id="element-500" />
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
                {/* İNGİLİZCE KARTI */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-purple-800" data-id="element-501">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-502">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-503">
                      İNGİLİZCE
                    </h3>
                    <div className="space-y-4" data-id="element-504">
                      {mostMistakesData['İNGİLİZCE'].map((item, index) => <div key={index} className="space-y-2" data-id="element-505">
                          <div className="flex justify-between items-center" data-id="element-506">
                            <span className="text-gray-300 font-medium" data-id="element-507">
                              {item.topic}
                            </span>
                          </div>
                          <div className="flex justify-between items-center text-sm" data-id="element-508">
                            <span className="text-red-400" data-id="element-509">
                              {item.mistakes} Yanlış
                            </span>
                            <span className="text-gray-400" data-id="element-510">
                              Başarı: {item.success.toFixed(1)}%
                            </span>
                          </div>
                          <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-511">
                            <div className="h-full bg-gradient-to-r from-purple-600 to-purple-800" style={{
                        width: `${item.success}%`
                      }} data-id="element-512" />
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
                {/* DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ KARTI */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-indigo-600 to-indigo-800" data-id="element-513">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-514">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-515">
                      DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ
                    </h3>
                    <div className="space-y-4" data-id="element-516">
                      {mostMistakesData['DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ'].map((item, index) => <div key={index} className="space-y-2" data-id="element-517">
                            <div className="flex justify-between items-center" data-id="element-518">
                              <span className="text-gray-300 font-medium" data-id="element-519">
                                {item.topic}
                              </span>
                            </div>
                            <div className="flex justify-between items-center text-sm" data-id="element-520">
                              <span className="text-red-400" data-id="element-521">
                                {item.mistakes} Yanlış
                              </span>
                              <span className="text-gray-400" data-id="element-522">
                                Başarı: {item.success.toFixed(1)}%
                              </span>
                            </div>
                            <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-523">
                              <div className="h-full bg-gradient-to-r from-indigo-600 to-indigo-800" style={{
                        width: `${item.success}%`
                      }} data-id="element-524" />
                            </div>
                          </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* SON DENEME TAB */}
      {activeTab === 'last' && <div className="space-y-6" data-id="element-525">
          {/* Son Deneme Özeti - LACİVERT TEMA */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-526">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-527">
              {/* Deneme Seçim Dropdown - GÜNCELLENDİ */}
              <div className="flex flex-col md:flex-row justify-between md:items-center mb-6" data-id="element-528">
                <div className="relative" data-id="element-529">
                  <button onClick={() => setShowExamDropdown(!showExamDropdown)} className="flex items-center gap-2 px-4 py-2 bg-white/5 rounded-lg hover:bg-white/10 transition-colors" data-id="element-530">
                    <span className="text-xl font-bold" data-id="element-531">
                      {currentExam.name}
                    </span>
                    <span className="text-gray-400" data-id="element-532">
                      {new Date(currentExam.date).toLocaleDateString('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                    </span>
                    <ChevronDown className={`w-5 h-5 transition-transform ${showExamDropdown ? 'rotate-180' : ''}`} data-id="element-533" />
                  </button>
                  {showExamDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-534">
                      {allExamsData.map(exam => <button key={exam.id} onClick={() => handleExamClick(exam)} className="w-full text-left px-4 py-2 hover:bg-blue-500/20 transition-colors flex justify-between items-center" data-id="element-535">
                          <span data-id="element-536">{exam.name}</span>
                          <span className="text-sm text-gray-400" data-id="element-537">
                            {new Date(exam.date).toLocaleDateString('tr-TR')}
                          </span>
                        </button>)}
                    </div>}
                </div>
              </div>
              {/* Pasta Grafiği ve İstatistikler - GÜNCELLENDİ */}
              <div className="flex flex-col items-center" data-id="element-538">
                <div className="h-80 w-full max-w-md" data-id="element-539">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-540">
                    <PieChart data-id="element-541">
                      <Pie data={[{
                    name: 'Doğru',
                    value: currentExam.totalCorrect
                  }, {
                    name: 'Yanlış',
                    value: currentExam.totalWrong
                  }, {
                    name: 'Boş',
                    value: currentExam.totalEmpty
                  }]} cx="50%" cy="50%" innerRadius={80} outerRadius={120} paddingAngle={5} dataKey="value" data-id="element-542">
                        <Cell fill="#4ade80" data-id="element-543" />
                        <Cell fill="#f87171" data-id="element-544" />
                        <Cell fill="#94a3b8" data-id="element-545" />
                      </Pie>
                      <Tooltip data-id="element-546" />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                <div className="mt-4 grid grid-cols-4 gap-8" data-id="element-547">
                  <div className="flex flex-col items-center" data-id="element-548">
                    <span className="text-sm text-gray-400" data-id="element-549">Toplam Net</span>
                    <span className="text-2xl font-bold text-white" data-id="element-550">
                      {currentExam.totalNet || currentExam.net}
                    </span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-551">
                    <span className="text-sm text-gray-400" data-id="element-552">Doğru</span>
                    <span className="text-2xl font-bold text-green-500" data-id="element-553">
                      {currentExam.totalCorrect}
                    </span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-554">
                    <span className="text-sm text-gray-400" data-id="element-555">Yanlış</span>
                    <span className="text-2xl font-bold text-red-500" data-id="element-556">
                      {currentExam.totalWrong}
                    </span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-557">
                    <span className="text-sm text-gray-400" data-id="element-558">Boş</span>
                    <span className="text-2xl font-bold text-gray-500" data-id="element-559">
                      {currentExam.totalEmpty}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Ders Bazlı Analiz Tablosu - GÜNCELLENDİ */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-560">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-561">
              <h2 className="text-xl font-bold mb-4" data-id="element-562">Ders Bazlı Analiz</h2>
              <div className="overflow-x-auto" data-id="element-563">
                <table className="w-full" data-id="element-564">
                  <thead data-id="element-565">
                    <tr className="border-b border-gray-800" data-id="element-566">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-567">
                        Ders
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-568">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-569">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-570">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-571">
                        Net
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-572">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-573">
                    {/* Ders satırları - RENK DEĞİŞTİRİLDİ */}
                    {currentExam.subjects.map((subject, index) => {
                  const successRate = subject.net / subject.questions * 100;
                  const gradientClass = VELI_DERS_RENKLERI[subject.subject] || 'from-blue-600 to-blue-800';
                  return <tr key={index} className="border-b border-gray-800/50 hover:bg-white/5 transition-colors" data-id="element-574">
                          <td className="px-4 py-3" data-id="element-575">
                            <span className="font-medium" data-id="element-576">
                              {subject.subject}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center text-green-500" data-id="element-577">
                            {subject.correct}
                          </td>
                          <td className="px-4 py-3 text-center text-red-500" data-id="element-578">
                            {subject.wrong}
                          </td>
                          <td className="px-4 py-3 text-center text-gray-500" data-id="element-579">
                            {subject.empty}
                          </td>
                          <td className="px-4 py-3 text-center" data-id="element-580">
                            {subject.net.toFixed(2)}
                          </td>
                          <td className="px-4 py-3" data-id="element-581">
                            <div className="flex items-center gap-2 justify-end" data-id="element-582">
                              <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-583">
                                <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${successRate}%`
                          }} data-id="element-584" />
                              </div>
                              <span className="text-xs text-white min-w-[45px] text-right" data-id="element-585">
                                {successRate.toFixed(1)}%
                              </span>
                            </div>
                          </td>
                        </tr>;
                })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* Konu Analizi - GÜNCELLENDİ */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-586">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-587">
              <h2 className="text-xl font-bold mb-6" data-id="element-588">Konu Analizi</h2>
              {/* Ders Seçim Dropdown - GÜNCELLENDİ - SADECE MEVCUT DENEMEDEKI DERSLERI GÖSTER */}
              <div className="flex justify-center mb-6" data-id="element-589">
                <div className="relative w-full max-w-xs" data-id="element-590">
                  <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-black/80 rounded-lg border border-blue-500/30 hover:border-blue-500/50 transition-colors" data-id="element-591">
                    <span className="text-white" data-id="element-592">{activeSubjectTab}</span>
                    <ChevronDown className={`w-5 h-5 text-blue-400 transition-transform ${showSubjectDropdown ? 'rotate-180' : ''}`} data-id="element-593" />
                  </button>
                  {showSubjectDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-594">
                      {currentExam.subjects.map(subject => {
                  const isSelected = activeSubjectTab === subject.subject;
                  return <button key={subject.subject} onClick={() => {
                    setActiveSubjectTab(subject.subject);
                    setShowSubjectDropdown(false);
                  }} className={`w-full text-left px-4 py-2 transition-colors ${isSelected ? 'bg-blue-500/20 text-blue-400' : 'text-white hover:bg-blue-500/10'}`} data-id="element-595">
                            {subject.subject}
                          </button>;
                })}
                    </div>}
                </div>
              </div>
              {/* Konu Tablosu - GÜNCELLENDİ */}
              <div className="overflow-x-auto" data-id="element-596">
                <table className="w-full" data-id="element-597">
                  <thead data-id="element-598">
                    <tr className="border-b border-gray-800" data-id="element-599">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-600">
                        Konu
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-601">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-602">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-603">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-604">
                        Net
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-605">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-606">
                    {/* Konu satırları - GÜNCELLENDİ */}
                    {getCurrentExamTopicData().map((topic, index) => {
                  const gradientClass = VELI_DERS_RENKLERI[activeSubjectTab] || 'from-blue-600 to-blue-800';
                  const successRate = topic.questions > 0 ? topic.net / topic.questions * 100 : 0;
                  return <tr key={index} className="border-b border-gray-800/50 hover:bg-white/5 transition-colors" data-id="element-607">
                          <td className="px-4 py-3" data-id="element-608">
                            <span className="font-medium" data-id="element-609">{topic.topic}</span>
                          </td>
                          <td className="px-4 py-3 text-center text-green-500" data-id="element-610">
                            {topic.correct}
                          </td>
                          <td className="px-4 py-3 text-center text-red-500" data-id="element-611">
                            {topic.wrong}
                          </td>
                          <td className="px-4 py-3 text-center text-gray-500" data-id="element-612">
                            {topic.empty}
                          </td>
                          <td className="px-4 py-3 text-center" data-id="element-613">
                            {topic.net?.toFixed(2) || '0.00'}
                          </td>
                          <td className="px-4 py-3" data-id="element-614">
                            <div className="flex items-center gap-2 justify-end" data-id="element-615">
                              <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-616">
                                <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${successRate}%`
                          }} data-id="element-617" />
                              </div>
                              <span className="text-xs text-white min-w-[45px] text-right" data-id="element-618">
                                {successRate.toFixed(1)}%
                              </span>
                            </div>
                          </td>
                        </tr>;
                })}
                    {/* Eğer konu verisi yoksa */}
                    {getCurrentExamTopicData().length === 0 && <tr data-id="element-619">
                        <td colSpan={6} className="px-4 py-8 text-center text-gray-400" data-id="element-620">
                          Bu ders için konu analizi bulunmuyor.
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      {/* KONU BAZLI GENEL ANALİZ TAB - SORUN 3 ÇÖZÜMÜ */}
      {activeTab === 'topic' && <div className="space-y-6" data-id="element-621">
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-622">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-623">
              <h2 className="text-xl font-bold mb-4" data-id="element-624">Konu Bazlı Analiz</h2>
              {/* Ders seçimi - GÜNCELLENDİ */}
              <div className="flex justify-center mb-6" data-id="element-625">
                <div className="relative w-full max-w-xs" data-id="element-626">
                  <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-black/80 rounded-lg border border-blue-500/30 hover:border-blue-500/50 transition-colors" data-id="element-627">
                    <span className="text-white" data-id="element-628">{activeSubjectTab}</span>
                    <ChevronDown className={`w-5 h-5 text-blue-400 transition-transform ${showSubjectDropdown ? 'rotate-180' : ''}`} data-id="element-629" />
                  </button>
                  {showSubjectDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-630">
                      {Object.keys(konuListeleri).map(subject => <button key={subject} onClick={() => {
                  setActiveSubjectTab(subject);
                  setShowSubjectDropdown(false);
                }} className={`w-full text-left px-4 py-2 transition-colors ${activeSubjectTab === subject ? 'bg-blue-500/20 text-blue-400' : 'text-white hover:bg-blue-500/10'}`} data-id="element-631">
                          {subject}
                        </button>)}
                    </div>}
                </div>
              </div>
              {/* Genel konu analizi tablosu - TÜM DENEMELER TOPLAMINI KULLANIYOR */}
              <div className="overflow-x-auto" data-id="element-632">
                <table className="w-full" data-id="element-633">
                  <thead data-id="element-634">
                    <tr className="border-b border-gray-800" data-id="element-635">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-636">
                        Konu
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-637">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-638">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-639">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-640">
                        Toplam Soru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-641">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-642">
                    {/* Konu satırları - TÜM DENEMELER TOPLAMINI KULLANIYOR */}
                    {tumDenemelerKonuAnalizi[activeSubjectTab].map((topic, index) => {
                  const gradientClass = VELI_DERS_RENKLERI[activeSubjectTab] || 'from-blue-600 to-blue-800';
                  return <tr key={index} className="border-b border-gray-800/50 hover:bg-white/5 transition-colors" data-id="element-643">
                            <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-644">
                              {topic.topic}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-645">
                              {topic.correct}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-646">
                              {topic.wrong}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-647">
                              {topic.empty}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-white" data-id="element-648">
                              {topic.totalQuestions}
                            </td>
                            <td className="px-4 py-3" data-id="element-649">
                              <div className="flex items-center gap-2 justify-end" data-id="element-650">
                                <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-651">
                                  <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${topic.accuracy}%`
                          }} data-id="element-652" />
                                </div>
                                <span className="text-xs text-white min-w-[45px] text-right" data-id="element-653">
                                  {topic.accuracy.toFixed(1)}%
                                </span>
                              </div>
                            </td>
                          </tr>;
                })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}